import { Controller, useFormContext } from 'react-hook-form';
import { cx } from '@/utils/cx';
import type { SignupFormValues } from '../schema';

// Usamos textarea nativo (em vez do TextArea de react-aria-components) para
// evitar a borda dupla no focus -- o wrapper AriaTextField mais o ring do
// AriaTextArea criavam dois aneis sobrepostos. Aqui aplicamos o estilo
// diretamente no <textarea> com ring unico (Untitled UI shadow-xs).
export const Step14Gargalo = () => {
  const {
    control,
    trigger,
    formState: { errors },
  } = useFormContext<SignupFormValues>();
  const errorMessage = errors.gargalo?.message;

  return (
    <Controller
      control={control}
      name="gargalo"
      render={({ field }) => (
        <div className="flex flex-col gap-1.5">
          <textarea
            {...field}
            rows={5}
            autoFocus
            placeholder="Ex.: Conseguir leads qualificados B2B na região Centro-Oeste."
            value={field.value ?? ''}
            onChange={(event) => {
              field.onChange(event);
              // Se ja havia erro, re-valida a cada digitacao para liberar o
              // botao Continuar assim que o campo voltar a ficar valido.
              // (reValidateMode do RHF so dispara apos handleSubmit; aqui
              // usamos trigger manual para o caso de validacao via trigger().)
              if (errorMessage) {
                void trigger('gargalo');
              }
            }}
            className={cx(
              'min-h-[140px] w-full resize-y rounded-lg bg-white px-3.5 py-3 text-md text-gray-900',
              'shadow-xs ring-1 ring-inset ring-gray-300 placeholder:text-gray-400',
              'transition-shadow focus:outline-none focus:ring-2 focus:ring-gray-900',
              errorMessage && 'ring-red-500 focus:ring-red-500',
            )}
          />
          <p
            className={cx(
              'text-sm',
              errorMessage ? 'font-medium text-red-600' : 'text-gray-500',
            )}
            role={errorMessage ? 'alert' : undefined}
          >
            {errorMessage ??
              'Seja específico. Ajuda o algoritmo a encontrar conexões certas.'}
          </p>
        </div>
      )}
    />
  );
};
